import React, { Component } from 'react';
import RichTextEditor from 'react-rte';

export default class Editor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      richValue: RichTextEditor.createValueFromString(props.value, 'html'),
      htmlValue: props.value
    };

    this.onChange = this.onChange.bind(this);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.value !== this.state.htmlValue) {
      this.setState({
        richValue: RichTextEditor.createValueFromString(newProps.value, 'html'),
        htmlValue: newProps.value
      });
    }
  }

  onChange(richValue) {
    this.setState({ richValue, htmlValue: richValue.toString('html') }, () => {
      this.props.onChange(this.state.htmlValue);
    });
  }

  render() {
    return (
      <RichTextEditor value={this.state.richValue} onChange={this.onChange} />
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Editor/index.js